export class Member {
    constructor(
      public id?:          string,
      public name?:        string,
      public lastname?:    string,
      public country?:     string,
      public pg?:          string,
      public position?:    string,
      public  priority?:   Number,
    ) { }
  }
